"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifyCustomerByCustomerNumberResponseToJSON = exports.IdentifyCustomerByCustomerNumberResponseFromJSONTyped = exports.IdentifyCustomerByCustomerNumberResponseFromJSON = void 0;
var _1 = require("./");
function IdentifyCustomerByCustomerNumberResponseFromJSON(json) {
    return IdentifyCustomerByCustomerNumberResponseFromJSONTyped(json, false);
}
exports.IdentifyCustomerByCustomerNumberResponseFromJSON = IdentifyCustomerByCustomerNumberResponseFromJSON;
function IdentifyCustomerByCustomerNumberResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'matches': (json['matches'].map(_1.IdentifyCustomerByCustomerNumberResponseMatchesFromJSON)),
    };
}
exports.IdentifyCustomerByCustomerNumberResponseFromJSONTyped = IdentifyCustomerByCustomerNumberResponseFromJSONTyped;
function IdentifyCustomerByCustomerNumberResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'matches': (value.matches.map(_1.IdentifyCustomerByCustomerNumberResponseMatchesToJSON)),
    };
}
exports.IdentifyCustomerByCustomerNumberResponseToJSON = IdentifyCustomerByCustomerNumberResponseToJSON;
//# sourceMappingURL=IdentifyCustomerByCustomerNumberResponse.js.map